export default "__VITE_ASSET__Cetl5dog__"